import {Field, ValueInputRendererProps} from 'apstra-ui-common';
import {FC} from 'react';

export const WidgetStageSearchBox: FC<ValueInputRendererProps> = ({
  value, values, selectedStageInfo, onChange, SearchBoxComponent
}) => {
  const {probe, stage, processor} = selectedStageInfo;
  return (
    <Field width={16}>
      <SearchBoxComponent
        key={stage.name}
        aria-label='Search'
        probe={probe}
        processor={processor}
        stage={stage}
        dataSource={values.data_source}
        filters={value}
        applyOnChange
        onChange={onChange}
      />
    </Field>
  );
};
